import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Mixpanel } from '../../redux/Mixpanel';
import UploadFile from './UploadFile';
import AssignTenantForm from './AssignPaymentToTenantForm';
import { withRouter } from 'react-router-dom';

import {
    Container,
    Button,
    Row,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    InputGroup,
    UncontrolledTooltip,
} from 'reactstrap';
import CustomInput from '../../components/CustomInput';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import {
    check_empty_field,
    check_if_number,
    check_date_field

} from './validationChecks';
import ShowMoreButton from './ShowMoreButton';
import CustomLabel from '../../components/CustomLabel';

import {
    addPayment,
    updatePayment,
    deletePayments,
    showLoading,
    fetchPropertyTenants,
    fetchPayments,
    showFeatureComingSoon,
    downloadFile,
    fetchPropertiesUnitsTenants,
    fetchOptions
} from '../../redux/actions';
import CustomPropertySelect from '../../components/CustomPropertySelect';
import { renderTenantSearchMenu } from '../../utils';
import * as PermChecker from '../../utils/PermUtils';
import fileDownload from 'js-file-download';
import {
    IonInput,
    IonText,
    IonIcon,
    IonButton,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonContent,
    IonItem,
    IonCheckbox,
    IonLabel,
} from '@ionic/react';
import { trashOutline } from 'ionicons/icons';


const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        options: state.options,
        payments: state.payments,
        invoices: state.invoices,
        user: state.user
    };
}

const mapDispatchToProps = {
    addPayment,
    showLoading,
    updatePayment,
    fetchPropertyTenants,
    showFeatureComingSoon,
    downloadFile,
    fetchPayments,
    fetchPropertiesUnitsTenants,
    fetchOptions,
    deletePayments
}


const HOME_PAGE = "home";
const PAGE_ASSIGN_TENANT = "assignTenant";


class PaymentForm extends React.Component{
    constructor(props){
        super(props);

        this.handleCloseAssignTenantModal = this.handleCloseAssignTenantModal.bind(this);

        this.state = {
            tenant: [],
            tenantDetails:  props.tenantDetails || null,
            propertyId: props.tenantDetails? props.tenantDetails.propertyId : "",
            properties: [],
            amount: "",
            description: "",
            bankTransactionId: "",
            paymentId: "",
            paymentDate: new Date().toISOString().split('T')[0],
            dateFocused: false,
            paymentType: [],
            tenantOptions: [],
            totalInvoiced: 0,
            lastUpdated: "",
            teamMemberId:"",
            createdBy: "",
            created: "",
            status: ['confirmed'],
            invoiceOptions:[],
            unpaidInvoices:[],
            sendReceipt: false,
            file: null,
            fileName: "",
            showOptionalFields: false,
            updateFile: false,
            readOnly: false,
            isPaymentIdFromPath: false,
            page: HOME_PAGE,
            creditNote: props.creditNote != null? props.creditNote: false,
            errors: {
                tenant: "",
                amount: "",
                description: "",
                paymentType: "",
                paymentDate: "",
                status: "",
                bankTransactionId: ""
            },
            numErrors: 0
        };
    }

    async setTenantOptions(propertyId=""){
        let tenantOptions = [];

        if(propertyId){
            this.props.showLoading(true);
            const action = await this.props.fetchPropertyTenants({propertyIds:[propertyId]});
            if(action && action.payload && action.payload.tenants){
                for(let tenant of Object.values(action.payload.tenants)){
                    if(!tenant.archived){
                        tenantOptions.push(this.getTenantOption(tenant));
                    }
                }
            }
        }
        let selectedTenant = this.getTenantOption(this.state.tenantDetails);
        this.setState({
            tenantOptions,
            tenant: selectedTenant? [selectedTenant] : []
        });
    }

    getTenantOption(tenant){
        if (tenant){
            let label = "";
            if(tenant?.archived){
                label += "[Archived] - "
            }
            label += tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }

            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label: label
            };
        }{
            return null;
        }
    }


    async handleSelectProperty(event){
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId } = prevState;
            if (propertyId != value){
                this.setTenantOptions(value);
                propertyId = value;
            }
            return {
                propertyId
            };
        });
    }

    async fetchInitialData(paymentId){
        if(_.isEmpty(this.props.properties) || _.isEmpty(this.props.tenants)){
            this.props.showLoading(true);
            await this.props.fetchPropertiesUnitsTenants();
            this.props.showLoading(false);
        }
        await Promise.all([
            (
                async () => {
                    this.props.showLoading(true);
                    let params={
                        paymentIds: [paymentId], tenantIds:[], propertyIds:[], unitIds:[],
                        startDate: "", endDate:"",minAmount:0, maxAmount:0, status: [],
                        unassigned:false, offset:"",source: "", appendData: true
                    }
                    await this.props.fetchPayments(params);
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.options)){
                        this.props.showLoading(true);
                        await this.props.fetchOptions();
                    }
                }
            )()
        ]);
    }

    async componentDidMount(){
        const re = /\d+$/;
        const path = this.props.location.pathname;
        const startIndex = this.props.location.pathname.search(re);
        const hasAllPaymentPerm = PermChecker.checkUserHasPermission(
            PermChecker.PAYMENT_MODEL,
            PermChecker.ALL_PERM,
            this.props.options?.userPermissions
        );

        let paymentId = this.props.paymentId;
        if(paymentId || startIndex != -1){
            if(startIndex != -1){
                const endIndex = path.length;
                paymentId = path.substr(startIndex, endIndex);
            }
            if(!this.props.payments[paymentId]) {
                await this.fetchInitialData(paymentId);
            }
            const tenant = this.props.payments[paymentId].tenant;
            this.setState({
                isPaymentIdFromPath: startIndex != -1,
                tenantDetails: tenant,
                propertyId: tenant? tenant.propertyId: ""
            })
        }

        if (this.state.tenantDetails){
            this.setTenantOptions(this.state.tenantDetails.propertyId);
        }else {
            // If only one property exists then:
            // preselect the property and fetch tenants for that property.
            const propertIds = Object.keys(this.props.properties);
            if( propertIds.length == 1){
                this.setState({propertyId: propertIds[0]});
                this.setTenantOptions(propertIds[0])
            }
        }

        if (paymentId){
            let payment = this.props.payments[paymentId]

            this.setState({
                amount: payment.amount,
                description: payment.description,

                paymentId,
                totalInvoiced: payment.totalInvoiced,
                lastUpdated: payment.lastUpdated,
                teamMemberId: payment.teamMemberId,
                createdBy: payment.createdBy,
                bankTransactionId: payment.bankTransactionId,
                paymentType: [payment.type],
                created: payment.created,
                status: [payment.status],
                readOnly: !hasAllPaymentPerm,
                creditNote: payment.creditNote,
                paymentDate: payment.paymentDate ? payment.paymentDate.slice(0, 10) : payment.created.toISOString().split('T')[0],
                fileName: payment.fileName,
                fileId: payment.fileId,
                showOptionalFields: true
            });
        }
        this.setState({
            properties: Object.values(this.props.properties)
        });
        Mixpanel.track("Payment form: mounted");
    }

    async validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let checks = [];

        switch(name){
            case "status":
                checks = [check_empty_field];
                break;
            case "amount":
                checks = [check_empty_field, check_if_number];
                break;
            case "paymentDate":
                checks = [check_date_field]
                break
            default:
                break;
        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }

    handleChange(event){
        event.preventDefault();
        let target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});

        this.validateInput(name, val);
    }

    handleSendReceiptChange = (e) => {
        const checked = e.detail?.checked ?? e.target?.checked;
        this.setState({ sendReceipt: !!checked });
    };

    async handleChangedOptions(name, selected){
        this.setState({[name]: selected});
        this.validateInput(name, selected);
    }

    async handleSubmit(event){
        event.preventDefault();
        let fields = ["tenant", "amount", "paymentDate"];
        let results = [];
        for(let field of fields){
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);

        if(invalid_fields.length == 0){
            let tenantPayment = {
                tenantId: this.state.tenant.length !== 0 ? this.state.tenant[0].tenantDetails.tenantId : "",
                amount: this.state.amount,
                description: this.state.description,
                paymentType: this.state.paymentType[0],
                creditNote: this.state.creditNote,
                status: this.state.status[0],
                paymentDate: this.state.paymentDate ? this.state.paymentDate.slice(0, 10) : "",
                fileUpload: this.state.file,
                updateFile: this.state.updateFile,
                bankTransactionId: this.state.bankTransactionId,
                sendReceipt: this.state.sendReceipt
            };
            this.props.showLoading(true);
            let result;
            if (this.state.paymentId === "") {
                result = await this.props.addPayment(tenantPayment);
            } else {
                tenantPayment.paymentId = this.state.paymentId;
                result = await this.props.updatePayment(tenantPayment);
            }
            if (result && result.payload && result.payload.payment) {
                const payment = result.payload.payment;
                this.setState({
                    createdBy: payment.createdBy,
                    created: payment.created,
                    paymentId: payment.paymentId,
                    fileUpload: null,
                    fileName: payment.fileName,
                    fileId: payment.fileId,
                    paymentDate: payment.paymentDate ? payment.paymentDate.slice(0, 10) : this.state.paymentDate
                });
            }
        }
        Mixpanel.track("Payment form: submit btn");
    }

    async handleDelete(event){
        event.preventDefault();
        if(confirm("Are you sure you want to delete this payment?")){
            this.props.showLoading(true);
            const paymentIds=[this.state.paymentId]
            const action = await this.props.deletePayments(paymentIds);
            if(!action.errors){
                this.setPaymentValues();
            }
        }
    }

    handleClear(event){
        event.preventDefault();
        this.setPaymentValues();
        Mixpanel.track("Payment form: clear btn");
    }

    setPaymentValues(paymentId="", tenant=[], paymentType=[], amount="", description="", totalInvoiced="",
        lastUpdated="", teamMemberId="",status=['confirmed'], createdBy="", created="", paymentDate=null, readOnly=false){
        this.setState({
            paymentId, tenant, paymentType, amount, description,
            lastUpdated, teamMemberId, createdBy, status, created, totalInvoiced,
            paymentDate, readOnly
        });
    }

    onClickUploadSpreadSheet(event){
        event.preventDefault();
        this.props.showFeatureComingSoon();
        Mixpanel.track("Payment form: upload spreadsheet btn");
    }

    handleDownloadFile(){
        if (this.state.fileName && this.state.fileId){
            this.props.showLoading(true);
            Mixpanel.track("Payment form: download file");
            this.props.downloadFile({
                itemType: "payment",
                fileId: this.state.fileId,
                fileName: this.state.fileName
            });
        }else if(this.state.file){
            fileDownload(this.state.file, this.state.file.name);
        }
    }

    handleChangeFile(event){
        this.setState({
            fileId: "",
            updateFile: true,
            file: event.target.files[0],
            fileName: event.target.files[0].name
        });
    }

    handleClose(){
        this.setState({updateFile: true, fileId: "", file: null, fileName: ""});
    }

    renderRequiredFields(){
        return (
            <React.Fragment>

                {(this.state.paymentId && this.state.readOnly)  && (
                    <FormGroup  row>
                        <CustomLabel sm={12} md={3} for="paymentStatus"/>
                        <Col sm={12} md={8} className="">
                            <h6 className='text-danger' >
                                Payment in '{this.state.status[0]}'' status is read only for non admins
                            </h6>
                        </Col>
                    </FormGroup>
                )}

                {this.state.createdBy &&
                <FormGroup  row>
                    <CustomLabel sm={12} md={3} for="created By"/>
                    <Col sm={12} md={8} className="">
                    <h6 className='text-info'>{this.state.createdBy} on {new Date(this.state.created).toLocaleString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</h6>
                    </Col>
                </FormGroup>
                }

                {/* Select Tenant */}
                <FormGroup  row>
                    <CustomLabel
                        sm={12} md={3}
                        for="propertyId">
                            Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                    </CustomLabel>

                    <Col sm={12} md={8} className="">
                        {!(this.state.paymentId && !this.state.propertyId) && (<Row>
                            <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                                <CustomInput
                                    type="select"
                                    id="propertyId"
                                    name="propertyId"
                                    className="mr-2"
                                    disabled={this.state.readOnly}
                                    onChange={this.handleSelectProperty.bind(this)}
                                    value={this.state.propertyId}
                                >
                                    <CustomPropertySelect propertiesArray={this.state.properties}/>
                                </CustomInput>
                            </Col>

                            <Col id='tenantPayment' className="mt-2" style={{maxWidth: '450px'}} xs={12} sm={12}>
                                <Typeahead
                                    emptyLabel={this.state.propertyId==="" ? "Please first select tenant property." : "Choose tenant. No matches found."}
                                    id="tenant"
                                    placeholder={`Select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"} ...`}
                                    disabled={this.state.readOnly}
                                    clearButton
                                    options={this.state.tenantOptions}
                                    name="tenant"
                                    selected={this.state.tenant}
                                    paginate={false}
                                    maxResults={10000000}  // chose a high number because we don't want to handle pagination. Just show all results.
                                    renderMenu={renderTenantSearchMenu}
                                    onChange={this.handleChangedOptions.bind(this, "tenant")}
                                >
                                </Typeahead>
                                {this.state.errors.tenant.length > 0 && <p className="text-danger">{this.state.errors.tenant}</p>}
                            </Col>
                        </Row>
                        )}

                        {(this.state.paymentId && !this.state.propertyId) && (<Row>
                            <Col style={{maxWidth: '450px'}} xs={12} sm={12}>
                                <IonButton
                                    className='shadow m-1'
                                    size='md'
                                    onClick={this.onClickAssignTenant.bind(this)}
                                    value={this.state.paymentId}
                                >
                                    Assign {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}
                                </IonButton>
                            </Col>
                        </Row>
                        )}
                    </Col>

                </FormGroup>

                {/* Amount */}
                <FormGroup row>
                    <CustomLabel
                        sm={12} md={3}
                        for={"amount"}
                    >
                        Paid Amount
                    </CustomLabel>

                    <Col style={{maxWidth: '250px'}} sm={12} md={8}>
                        <InputGroup>
                            <Input
                                id="amount"
                                readOnly={this.state.readOnly}
                                name="amount"
                                value={this.state.amount}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.amount.length > 0}
                            />
                            <FormFeedback>{this.state.errors.amount}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

                {/* Date */}
                <FormGroup row>
                    <CustomLabel sm={12} md={3} for="paymentDate">
                        Payment Date
                    </CustomLabel>

                    <Col style={{maxWidth: '250px'}} sm={12} md={8}>
                        <IonInput
                            id="paymentDate"
                            type="date"
                            fill="solid"
                            value={this.state.paymentDate}
                            onIonChange={(e) => {
                                const paymentDate = e.detail.value;
                                this.setState({ paymentDate });
                                this.validateInput("paymentDate", paymentDate);
                            }}
                        />

                        {this.state.errors.paymentDate.length > 0 && <p className="text-danger">{this.state.errors.paymentDate}</p>}
                    </Col>

                </FormGroup>

                {/* Status */}
                <FormGroup row>
                    <CustomLabel  sm={12} md={3} for="paymentType">
                        Status
                        <i id="infoStatus" className="fa fa-fw fa-info-circle ml-2"></i>
                    </CustomLabel>
                    <UncontrolledTooltip placement="top" target="infoStatus">
                        <p>Draft - payment that has NOT been verified.</p>
                        <p>Confirmed - Payment that has been verified. </p>
                    </UncontrolledTooltip>

                    <Col id='statusContainer' style={{maxWidth: '250px'}} sm={12} md={8}>
                        <Typeahead
                            clearButton
                            disabled={this.state.readOnly}
                            id="status"
                            options={["draft", "confirmed"]}
                            name="status"
                            selected={this.state.status}
                            onChange={this.handleChangedOptions.bind(this, "status")}
                        >
                        </Typeahead>

                        {this.state.errors.paymentType.length > 0 && <p className="text-danger">{this.state.errors.status}</p>}
                    </Col>
                </FormGroup>

                {/* Send receipt (when tenant/member is selected - add or update) */}
                {this.state.tenant.length > 0 && (
                    <FormGroup row>
                        <Col sm={12} md={{ size: 8, offset: 3 }}>
                            <IonItem lines="none" className="ion-no-padding">
                                <IonCheckbox
                                    slot="start"
                                    id="sendReceipt"
                                    name="sendReceipt"
                                    checked={!!this.state.sendReceipt}
                                    onIonChange={this.handleSendReceiptChange}
                                    disabled={this.state.readOnly}
                                />
                                <IonLabel className="ion-text-wrap">
                                    Send receipt to {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}
                                </IonLabel>
                            </IonItem>
                        </Col>
                    </FormGroup>
                )}
            </React.Fragment>
        )
    }

    renderOptionalFields(){
        return <React.Fragment>
            {/* Payment type */}
            <FormGroup row>
                <CustomLabel sm={12} md={3} for="paymentType">
                    Payment Type (optional)
                </CustomLabel>
                <Col id='paymentType'  style={{maxWidth: '250px'}} sm={12} md={8}>
                    <Typeahead
                        clearButton
                        disabled={this.state.readOnly}
                        options={this.props.options.paymentTypes}
                        name="paymentType"
                        selected={this.state.paymentType}
                        onChange={this.handleChangedOptions.bind(this, "paymentType")}
                    >
                    </Typeahead>
                    {this.state.errors.paymentType.length > 0 && <p className="text-danger">{this.state.errors.paymentType}</p>}
                </Col>
            </FormGroup>

            {/* Description */}
            <FormGroup row>
                <CustomLabel sm={12} md={3} for={"description"}>
                    Description (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="description"
                            name="description"
                            type="textarea"
                            readOnly={this.state.readOnly}
                            value={this.state.description}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.description.length > 0}
                        />
                        <FormFeedback>{this.state.errors.description}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>

            {/* Bank Transaction ID */}
            <FormGroup row>
                <CustomLabel sm={12} md={3} for={"bankTransactionId"}>
                    Bank Transaction ID (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={8}>
                    <InputGroup>
                        <Input
                            id="bankTransactionId"
                            name="bankTransactionId"
                            readOnly={this.state.readOnly}
                            value={this.state.bankTransactionId}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.bankTransactionId.length > 0}
                        />
                        <FormFeedback>{this.state.errors.bankTransactionId}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>

            {/* File upload */}
            <FormGroup row>
                <CustomLabel sm={12} md={3}  for={"fileUpload"}>
                    File upload (optional)
                </CustomLabel>
                <Col style={{minWidth: '300px'}} sm={12} md={8}>
                    <UploadFile
                        readOnly={this.state.readOnly}
                        fileName={this.state.fileName}
                        file={this.state.file}
                        noShowLabel={true}
                        label={"File upload (optional"}
                        handleDownloadFile={this.handleDownloadFile.bind(this)}
                        handleChangeFile={this.handleChangeFile.bind(this)}
                        handleClose={this.handleClose.bind(this)}
                    />
                    <p>File can be receipt, proof of payment etc.</p>
                </Col>
            </FormGroup>

        </React.Fragment>
    }

    renderButtons(){
        return (
            <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                <IonButton type="submit"
                    id="updatePayment"
                    className="shadow py-1"
                    style={{ width: "80%" }}
                    size="lg"
                    onClick={this.handleSubmit.bind(this)}
                    disabled={this.state.numErrors > 0 || this.state.readOnly}>
                    {this.state.paymentId?
                        <span><i className="fa fa-fw fa-refresh mr-1"></i>Update Payment</span>:
                        <span><i className="fa fa-fw fa-plus mr-1"></i>Add Payment</span>
                    }
                </IonButton>

                {this.state.paymentId && (
                <IonButton
                    type="submit"
                    id="clearPayment"
                    size="lg"
                    style={{ width: "80%" }}
                    onClick={this.handleClear.bind(this)}
                    className="mt-3 py-1"
                    fill='outline'
                >
                    <span><i className="fa fa-fw fa-plus mr-1"></i>Add Another Payment</span>
                </IonButton>
                )}

            </Row>

        );
    }

    onClickAssignTenant(event){
        event.preventDefault()
        Mixpanel.track("Payments form: Assign payment to tenant button");
        let paymentId = event.target.value;
        this.setState({paymentId, page: PAGE_ASSIGN_TENANT});
    }

    handleCloseAssignTenantModal(){
        const { paymentId } = this.state;
        const tenant = this.props.payments[paymentId].tenant;
        let selectedTenant = this.getTenantOption(tenant);
        let propertyId = tenant? tenant.propertyId: "";
        this.setTenantOptions(propertyId);
        this.setState({
            tenantDetails: tenant,
            propertyId,
            tenant: selectedTenant? [selectedTenant] : [],
            page: HOME_PAGE
        });
    }

    renderAssignTenantModal(){
        return (
            <IonModal isOpen={this.state.page === PAGE_ASSIGN_TENANT} onDidDismiss={this.handleCloseAssignTenantModal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Assign Payment to {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}</IonTitle>
                        <IonButtons slot="end">
                            <IonButton id='closeAssignTenantForm' onClick={this.handleCloseAssignTenantModal}>
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                <AssignTenantForm
                    dataName={"tenants"}
                    paymentId={this.state.paymentId}
                    unassignedFilter={this.state.unassigned}/>
            </IonContent>
            </IonModal>);
    }

    renderHomePage(){
        return (
            <Container className='mx-1 mt-3'>

                <Row className="mb-2 mr-1">
                    <Col className='px-1 mx-0 mb-2' lg={9} md={8} sm={8} xs={10}>
                        {/* <h1 data-testid="paymentFormTitle">{ this.state.creditNote? "Credit Note" : "Payment" } Form</h1> */}
                        <IonText>Use this form to save {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} payments.</IonText>
                    </Col>
                    <Col className='px-0 mx-0' lg={3} md={4} sm={4} xs={2}>
                        {this.state.paymentId && (<IonButton
                            size="lg"
                            color="medium"
                            className="mx-2 shadow"
                            id="deletePayment"
                            onClick={this.handleDelete.bind(this)}
                            disabled={this.state.readOnly}
                            data-testid="deletePayment"
                        >
                            <IonIcon icon={trashOutline} />
                        </IonButton>)}
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>

                        {this.renderRequiredFields()}

                        <ShowMoreButton
                            id="showOptionalFields"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({showOptionalFields: !prevState.showOptionalFields}))
                            }}
                            showMore={this.state.showOptionalFields}
                        />

                        {this.state.showOptionalFields && this.renderOptionalFields()}

                        {this.renderButtons()}
                    </Col>
                </Row>
            </Container>
        );
    }

    render(){
        return (
        <React.Fragment>
            {this.state.page === PAGE_ASSIGN_TENANT && this.renderAssignTenantModal()}
            {this.state.page === HOME_PAGE && this.renderHomePage()}
        </React.Fragment>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentForm));